import { render } from "./S88481.vue?vue&type=template&id=37a282cf"
const script = {}
script.render = render

export default script